/* Cosy featured reviews — desktop arrows for the review strip.
   The strip itself is a native scroll container, so this only adds buttons;
   swipe and keyboard scrolling work with or without this file. */
(function () {
  function init(root) {
    var strip = root.querySelector('.cosy-rev-c__item-wrapper');
    var nav = root.querySelector('.cosy-rev__nav');
    if (!nav) return;

    // Judge.me's raw fallback markup has a different structure — no strip to
    // drive, so drop the controls rather than leave dead buttons on the page.
    if (!strip) {
      nav.remove();
      return;
    }

    var prev = nav.querySelector('[data-dir="-1"]');
    var next = nav.querySelector('[data-dir="1"]');

    function step() {
      var card = strip.querySelector('.cosy-rev-c-item');
      var gap = parseFloat(getComputedStyle(strip).columnGap) || 20;
      return card ? card.getBoundingClientRect().width + gap : strip.clientWidth;
    }

    function update() {
      var max = strip.scrollWidth - strip.clientWidth;
      prev.disabled = strip.scrollLeft <= 1;
      next.disabled = strip.scrollLeft >= max - 1;
      // nothing to scroll: hide the controls entirely
      nav.hidden = max <= 1;
    }

    // Where we have asked the strip to end up. Chromium coalesces scrollBy
    // calls issued while a smooth scroll is still running, so clicking quickly
    // would barely advance. Stepping from our own target instead of from the
    // live scrollLeft makes each click count.
    var target = null;

    nav.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-dir]');
      if (!btn) return;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var max = strip.scrollWidth - strip.clientWidth;
      var from = target === null ? strip.scrollLeft : target;
      target = Math.max(0, Math.min(max, from + step() * Number(btn.dataset.dir)));
      strip.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
    });

    // Hand control back as soon as the person scrolls themselves.
    ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (evt) {
      strip.addEventListener(evt, function () { target = null; }, { passive: true });
    });

    strip.addEventListener('scroll', function () {
      // our animation has arrived — stop steering from the stale target
      if (target !== null && Math.abs(strip.scrollLeft - target) < 2) target = null;
      update();
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  function boot() {
    document.querySelectorAll('.cosy-rev__carousel').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // re-run when the section is re-rendered in the theme editor
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.cosy-rev__carousel').forEach(init);
  });
})();
